import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const URGENCY_CARDS = [
  {
    icon: 'ri-time-line',
    title: 'Risco de perda de prazos importantes',
    desc: 'Prazos processuais perdidos podem resultar em prejuízos irreversíveis para a defesa. Acompanhamento imediato é essencial para preservar seus direitos.',
  },
  {
    icon: 'ri-survey-line',
    title: 'Incerteza sobre estratégias jurídicas',
    desc: 'Decisões tomadas sem análise técnica adequada podem comprometer toda a linha defensiva. Cada movimento precisa ser calculado com precisão estratégica.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Impacto emocional prolongado sem orientação',
    desc: 'A ansiedade e o estresse prolongados afetam o raciocínio e podem levar a escolhas que prejudicam o resultado do caso. Orientação clara reduz o sofrimento.',
  },
];

export default function UrgencySection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-navy py-16 md:py-28 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <span className="font-montserrat text-green-cta text-xs tracking-widest uppercase">
            Urgência
          </span>
          <h2 className="font-cinzel font-bold text-white text-2xl md:text-4xl lg:text-5xl mt-3 leading-tight max-w-3xl mx-auto">
            A demora na orientação pode aumentar riscos e complicações
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {URGENCY_CARDS.map((card, i) => (
            <div
              key={i}
              className={`bg-navy-light border border-navy-border rounded-2xl p-6 md:p-8 transition-all duration-500 hover:border-navy-border/70 ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-10 h-10 rounded-full bg-navy-border flex items-center justify-center mb-4 transition-transform duration-300 hover:scale-110">
                <i className={`${card.icon} text-grey-light w-5 h-5 flex items-center justify-center`} />
              </div>
              <h3 className="font-cinzel font-bold text-white text-lg md:text-xl">
                {card.title}
              </h3>
              <p className="font-montserrat font-light text-grey-light text-sm mt-3 leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 text-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-cta text-navy font-montserrat font-semibold text-sm px-6 py-3 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
          >
            <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
            Falar com o Advogado no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}